import { useCallback, useContext, useMemo } from 'react';
import debounce from 'transmute/debounce';
import { getLogicGroupConditionsSize, isLogicGroupWithFilterValidationErrors, isLogicGroupWithIncompleteFilters } from '../filterQueryFormat/logic/LogicGroup';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export function useOnChangeHandlers() {
  const {
    getIsUngated,
    props: {
      strategy,
      onChange
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const handleChange = useMemo(() => debounce(500, (filter, handler) => {
    if (typeof handler !== 'function') {
      return;
    }
    let payload = undefined;
    const hasFilters = !!getLogicGroupConditionsSize(filter);
    const hasIncompleteFilters = hasFilters && isLogicGroupWithIncompleteFilters(filter, getIsUngated);
    const hasFilterValidationErrors = hasFilters && isLogicGroupWithFilterValidationErrors(filter);
    if (!hasIncompleteFilters && !hasFilterValidationErrors) {
      const filterQuery = strategy.serializer.toFormat(filter, getIsUngated, {
        useHoursFiltering: strategy.useHoursFiltering
      });
      payload = filterQuery;
    }
    handler(payload, {
      hasIncompleteFilters,
      hasFilterValidationErrors
    });
  }), [strategy, getIsUngated]);
  const handleOnChange = useCallback(filter => {
    handleChange(filter, onChange);
  }, [onChange, handleChange]);
  return {
    handleOnChange
  };
}